<template>
 <footer class="page-footer dark">
        <div class="container">
            <div class="row">
                <div class="col-sm-3">
                    <h5>About me</h5>
                    <ul>
                        <li>
                            <a href="https://twitter.com/tasiukwaplong">@tasiukwaplong</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="footer-copyright">
            <p>&copy; 2020</p>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'Foot'
}
</script>



// WEBPACK FOOTER //
// src/components/Foot.vue